import React from 'react';
import PropTypes from 'prop-types';
import EloadasContent from './EloadasContent';
import CustomTooltip from '../../../components/Tooltip/CustomTooltip';
import getTooltip from '../EsemenyekTooltips';

const cardStyle = {
  padding: 20
};

const EloadasBase = (props) => {
  return (
    <div>
      <div className="animated fadeIn">
        <div className="card">
          <div className="card-header">
            {'Előadások'}
            <CustomTooltip text={getTooltip('eloadasok')} id="eloadasokTT" />
          </div>
          <div className="row" style={cardStyle}>
            <div className="col-md-12">
              <EloadasContent {...props} globals={props.globals} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

EloadasBase.propTypes = {
  route: PropTypes.object,
  globals: PropTypes.object
};

export default EloadasBase;
